<style>
.login {
    background: radial-gradient(#e5e8ec 60%, #c0cdff);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
}

.inner {
    padding: 0 65px;
    box-sizing: border-box;
}

.inner .login_box {
    display: flex;
    width: 1100px;
    height: 655px;
    background-color: #fff;
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
    overflow: hidden
}

.inner .box_form ul li span {
    color: #ff4d4f;
    font-size: 14px;
}

.inner .box_form ul li p {
    padding-bottom: 8px;
}

.inner .box_form ul li {
    padding-bottom: 20px;
}

.inner .box_left {
    max-width: 480px;
    width: 100%;
    flex: 0 0 43.5%;
    padding: 85px 60px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    box-sizing: border-box;
}

.inner .box_left img {
    width: 88px;
    height: 88px;
    margin: 0 auto 56px;
}

.inner .box_right {
    background-image: url(../assets/img/login-right-bg.png);
    flex: 0 0 56.5%;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    filter: grayscale(8%);
    -webkit-filter: grayscale(8%);
}

.inner .box_right h2 {
    font-size: 38px;
    font-weight: 400;
    color: #00f0ff;
    letter-spacing: 1px;
}

.el-input__inner {
    height: 48px !important;
}

.login .login_box .box_form .land {
    width: 100%;
    background-color: #1677ff;
    text-align: center;
    font-size: 20px;
    color: #FFFFff;
    padding: 11px 0;
    border-radius: 5px;
    cursor: pointer;
}

.verify {
    max-width: 300px;
    background: #ffffff;
    width: 100%;
    position: fixed;
    top: 35%;
    left: 56%;
    padding: 30px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 10px;
    border: 1px solid #BBBABA;
}

.verify p {
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 20px;
}
</style>
<template>
    <div class="login">
        <div class="inner">
            <div class="login_box">
                <div class="box_left">
                    <img src="../assets/img/avatar-icon.png" alt="">
                    <div class="box_form">
                        <ul>
                            <li class="Username">
                                <p><span>*</span>Email</p>
                                <el-input placeholder="Email" v-model="box_account" clearable></el-input>
                                <span class="Username_error" v-if="account_display == 1">Please input your
                                    Email!</span>
                            </li>
                            <li class="Password">
                                <p><span>*</span>Password</p>
                                <el-input placeholder="password" v-model="box_password" show-password></el-input>
                                <span class="Password_error" v-if="password_display == 1">Please input your
                                    password!</span>
                            </li>
                            <li class="moving" v-if="this.result_dexq != ''">
                                <p><span>*</span>Verification code</p>
                                <el-input placeholder="Verification code" v-model="moving" clearable></el-input>
                                <span class="moving_error" v-if="moving_display == 1">Please input your Verification code!</span>
                                <span class="moving_error" v-if="moving_display == 3">{{ Verification }}</span>
                            </li>
                        </ul>
                        <div>
                            <span style="margin-bottom: 20px;display: block;color: red;font-size: 14px;" class="Password_error" v-if="Login_error != ''">{{ Login_error }}</span>
                        </div>
                        <div class="land" @click="getDatas()">Login</div>
                    </div>
                </div>
                <div class="box_right">
                    <img src="../assets/img/login-right-logo.png" alt="">
                    <h2>Hey Welcome Back</h2>
                </div>
            </div>
            <div class="verify" v-if="this.result_dexq == 1">
                <p>Please use Authenticator to scan the QR code to verify the ID</p>
                <img :src=result alt="">
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import Cookies from 'js-cookie'
export default {
    data () {
        return {
            box_account: '', //账号
            box_password: '',//密码
            account_display: '',
            password_display: '',
            moving_display: '',
            result: "",//二维码验证
            result_dexq: '',
            moving: "",//动态验证
            newswa: 1,//判断点击次数
            Login_error: '',
            Verification:'',
        }
    },
    watch: {
        'box_account' (oldval,) {
            if (oldval == "") {
                this.Login_error = ''
                this.account_display = 1,
                    $('.Username .el-input__inner').css("border", "1px solid #ff4d4f")
            } else {
                this.account_display = "",
                    $('.Username .el-input__inner').css("border", "1px solid #BBBABA")
            }
        },
        'box_password' (oldval,) {
            if (oldval == "") {
                this.Login_error = ''
                this.password_display = 1
                $('.Password .el-input__inner').css("border", "1px solid #ff4d4f")
            } else {
                this.password_display = ""
                $('.Password .el-input__inner').css("border", "1px solid #BBBABA")
            }
        },
        'moving' (oldval,) {
            if (oldval == "") {
                this.moving_display = 1
                $('.moving .el-input__inner').css("border", "1px solid #ff4d4f")
            } else {
                this.moving_display = ""
                $('.moving .el-input__inner').css("border", "1px solid #BBBABA")
            }
        },
    },
    created () {
    },
    mounted () {

    },
    methods: {
        getDatas () {
            if (this.newswa == 1) {
                if (this.box_account != "" & this.box_password != "") {
                    this.$axios
                        .post(
                            'https://google-analytics-test.canglankeji.com/api/auth/code',
                            {
                                email: this.box_account,
                                password: this.box_password,
                            },
                        )
                        .then((res) => {
                            // console.log(res)
                            if (res.data.code == 0) {
                                if (res.data.result == '') {
                                    this.result_dexq =  2
                                    this.newswa = 2
                                }else{
                                    this.Login_error = ''
                                    this.result = res.data.result
                                    this.newswa = 2
                                    this.result_dexq =  1
                                    $('.Password .el-input__inner').css("border", "1px solid #BBBABA")
                                    $('.Username .el-input__inner').css("border", "1px solid #BBBABA")
                                }
                            }
                            if (res.data.code == -1) {
                                this.newswa = 1
                                this.Login_error = res.data.message
                                $('.Password .el-input__inner').css("border", "1px solid #ff4d4f")
                                $('.Username .el-input__inner').css("border", "1px solid #ff4d4f")
                            }
                        })
                } 
                if(this.box_account == "") {
                    this.Login_error = ''
                    this.account_display = 1,
                    $('.Username .el-input__inner').css("border", "1px solid #ff4d4f")
                }
                if(this.box_password == "") {
                    this.Login_error = ''
                    this.password_display = 1
                    $('.Password .el-input__inner').css("border", "1px solid #ff4d4f")
                }
            } else {
                this.$axios
                    .post(
                        `https://google-analytics-test.canglankeji.com/api/auth/login`,
                        {
                            email: this.box_account,
                            password: this.box_password,
                            code: this.moving,
                        },
                    )
                    .then((res) => {
                        // console.log(res)
                        if (res.data.code == 0) {
                            Cookies.set('token', res.data.result.token)
                            Cookies.set('user_name', res.data.result.name, 1)
                            this.$router.push({
                                path: "/",
                            })
                        }else{
                            this.Verification = res.data.message
                            this.moving_display = 3
                            $('.moving .el-input__inner').css("border", "1px solid #ff4d4f")
                        }
                    })
            }
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/pages/login.vue